module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "open",
    class: {
      'open_solo': !_vm.helpText
    },
    on: {
      "click": function($event) {
        return _vm.$emit('openForm')
      }
    }
  }, [_c('button', {
    staticClass: "open__plus"
  }), _c('div', {
    staticClass: "open__text"
  }, [_c('div', {
    staticClass: "open__add"
  }, [_vm._v(_vm._s(_vm.mainText))]), (_vm.helpText) ? _c('div', {
    staticClass: "open__italian"
  }, [_vm._v(_vm._s(_vm.helpText))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ce6214e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/openform/OpenForm.vue
// module id = 141aed0d43e9e253c931
// module chunks = 89